var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-input", {
    attrs: { type: "number" },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    },
    model: {
      value: _vm.valueMutable,
      callback: function($$v) {
        _vm.valueMutable = $$v
      },
      expression: "valueMutable"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }